import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { PermissionService } from '@core/services/permission.service';
import { Permission } from '@shared/enums/permission.enum';
import { InterventionStore } from '../../../../intervention.store';

// The suicide risk screeners of the case (it can be repeated, so every one is listed). A screener has its own page; this is the way in to it.
// It sits in the Functional impact and risk step for the types with an assessment, and in the Presenting problem step for the types without one.
@Component({
  selector: 'risk-screener-panel',
  imports: [DatePipe, RouterLink, ...SharedMaterialUIModule],
  templateUrl: './risk-screener-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RiskScreenerPanelComponent {
  private readonly permissionService = inject(PermissionService);
  protected readonly store = inject(InterventionStore);

  readonly interventionId = input.required<string>();
  readonly interventionStatus = input<string | null>(null);

  constructor() {
    effect(() => {
      if (this.canView()) {
        this.store.loadRiskScreeners(this.interventionId());
      }
    });
  }

  protected canRecordScreener(): boolean {
    return this.canStart() && this.interventionStatus() !== 'Closed';
  }

  protected canView(): boolean {
    return this.permissionService.hasPermission(Permission.RiskScreenerRead);
  }

  protected canStart(): boolean {
    return this.permissionService.hasPermission(Permission.RiskScreenerCreate);
  }
}
